module.exports = __webpack_public_path__ + "img/4-4.70df9bcb.png";